import React from 'react'
import { IconArrowRight } from '../icons'

export const PageButton = ({data,onClick}) => {
  return <button aria-label={data.text} className={`btn-arrow ${data.class}`} onClick={ e=>onClick( data.url ) }>
    <IconArrowRight/>
    <span dangerouslySetInnerHTML={{__html: data.text}}></span>
  </button>
}